import React from "react";
import { FaPhoneAlt } from "react-icons/fa";

export default function FloatingCallButton() {
  return (
    <a
      href="tel:0400000000" // <-- replace with café number
      className="fab-call"
      aria-label="Call Burro Henley"
    >
      <FaPhoneAlt />
    </a>
  );
}
